
export const SET_ID = 'SET_ID' ;
export const SET_UNLICENSED = 'SET_UNLICENSED' ;
export const SET_TRIAL = 'SET_TRIAL' ;
export const SET_DEVICE = 'SET_DEVICE' ;
export const SHOW_WELCOME = 'SHOW_WELCOME'

export function ShowWelcome(payload){
    return {
        type:'SHOW_WELCOME',
        payload
    }
}

export function SetId(payload){
    return {
        type:'SET_ID',
        payload
    }
}

export function SetTrial(payload){
    return {
        type:'SET_TRIAL',
        payload
    }
}

export function SetUnlicensed(payload){
    return {
        type:'SET_UNLICENSED',
        payload
    }
}

export function SetDevice(payload){
    return {
        type:'SET_DEVICE',
        payload
    }
}

